import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { disableNetworkElementAutoSwitch } from '@api/networkElements';

import { IId } from '@interfaces/common/common';
import { INetworkElement } from '@interfaces/networkElements/networkElements';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { NETWORK_ELEMENTS_DISABLE_AUTO_SWITCH } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

import useInvalidateNetworkElements from './useInvalidateNetworkElements';

interface IUseMutateNetworkElementDisableAutoSwitchReturned {
	disableNetworkElementAutoSwitch: (id: IId) => Promise<INetworkElement>;
	isLoadingDisableNetworkElementAutoSwitch: boolean;
}

const useMutateNetworkElementDisableAutoSwitch = (
	handleCloseModal: () => void,
): IUseMutateNetworkElementDisableAutoSwitchReturned => {
	const dispatch = useAppDispatch();
	const invalidateNetworkElements = useInvalidateNetworkElements();

	const {
		isLoading,
		mutateAsync,
	} = useMutation<IId>({
		mutationKey: [NETWORK_ELEMENTS_DISABLE_AUTO_SWITCH],
		mutationFn: disableNetworkElementAutoSwitch,
		onSuccess: (data: INetworkElement) => {
			handleCloseModal();

			dispatch(setSnackbar({
				message: responseMessages.networkElementUpdated(data.name),
				type: ESnackbarTypes.success,
			}));

			return invalidateNetworkElements();
		},
		allowedRoles: [EUserRoles.smoLightUpdater],
	});

	return {
		disableNetworkElementAutoSwitch: mutateAsync,
		isLoadingDisableNetworkElementAutoSwitch: isLoading,
	};
};

export default useMutateNetworkElementDisableAutoSwitch;
